import script from "./PAN-card-design.vue?vue&type=script&setup=true&lang=js"
export * from "./PAN-card-design.vue?vue&type=script&setup=true&lang=js"

import "./PAN-card-design.vue?vue&type=style&index=0&id=f87f3e14&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f87f3e14"]])

export default __exports__